<div class="page-container">
  <div class="flex min-w-0 items-center justify-between gap-4">
    <h1 class="main-heading min-w-0">
      <fa-icon [icon]="faIcons.faUsers" />
      Manage Control Parameters
    </h1>
    <app-navpath class="hidden md:block" />
  </div>
  <div class="content-container">
    <h2 class="sub-heading w-full border-b">
      Control Parameters detail
    </h2>
    <app-data-form
      [dataFields]="controlParametersDetail"
      (updateFields_child)="updateFields($event)"
      (clickAdd)="addEntry($event)"
    />
    <div
      *ngIf="RoyaltyDiscounts.length > 0"
      class="w-full overflow-x-auto"
    >
      <app-data-table
        [tableHeaders]="tableHeaders"
        [tableEntries]="processRoyaltyDiscount(RoyaltyDiscounts)"
        (remove)="removeEntry($event)"
        [pagination]="false"
        class="block min-w-[20rem] px-0 md:px-10"
      />
    </div>
    <div class="mt-4 flex w-full flex-col gap-1 md:w-fit md:flex-row">
      <button class="shorter-btn misc-btn" (click)="update()">
        <fa-icon [icon]="faIcons.faPencil" class="mr-1" />Update
      </button>
      <button class="shorter-btn misc-btn" (click)="printSummary()">
        <fa-icon [icon]="faIcons.faPrint" class="mr-1" />Print Stock
        Summary Report
      </button>
      <button
        class="shorter-btn misc-btn"
        (click)="tradeNetIntegration()"
      >
        <fa-icon [icon]="faIcons.faPrint" class="mr-1" />TradeNet Sync
      </button>
    </div>
  </div>
  <div class="content-container">
    <h2 class="sub-heading w-full border-b">Test Drive Report</h2>
    <app-data-form [dataFields]="testDriveReport" />
    <button
      class="shorter-btn misc-btn mt-4 w-full md:w-fit"
      (click)="printDriveReport()"
    >
      <fa-icon [icon]="faIcons.faPrint" class="mr-1" />Print
    </button>
  </div>
</div>
